import state from "./moduleCdnState.js";
import mutations from "./moduleCdnMutations.js";
import actions from "./moduleCdnActions.js";
import getters from "./moduleCdnGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
